<template>
    <b-sidebar id="vehicle-sidebar" title="Vehicles" shadow right>
        <b-list-group>
            <b-list-group-item
                v-for="(vehicle, idx) in data"
                :key="idx"
            >
                <div class="d-flex justify-content-between align-items-center vehicle-info">
                    {{vehicle.name}}
                    <span>
                        <b-checkbox v-model="vehicle.active" switch></b-checkbox>
                        <i v-b-toggle="`vehicle-${idx}`" class="bi bi-pencil-square edit-button" title="Edit vehicle"></i>
                        <button type="button" class="close" aria-label="Close" title="Delete Vehicle" @click="deleteVehicle(vehicle.name)" style="margin-top:-3px;">
                            <span aria-hidden="true">×</span>
                        </button>
                    </span>
                </div>
                <b-collapse :id="`vehicle-${idx}`">
                    <b-form>
                        <b-form-group v-for="attribute in attributes" :key="attribute.name" :label="`${attribute.label}:`">
                            <b-form-input
                                class="vehicle-input"
                                v-model="vehicle[attribute.name]"
                                :placeholder="attribute.placeholder"
                                :type="attribute.type ? attribute.type : 'text'"
                                min="0"
                                :step="attribute.step"
                                :max="attribute.max"
                                ></b-form-input>
                                <b-form-text v-if="attribute.required">Required</b-form-text>
                        </b-form-group>
                        <b-form-textarea v-model="vehicle.rawBody" rows="10" required />
                        <b-form-text>Required</b-form-text>
                    </b-form>
                    <!-- TODO: Body input field -->
                </b-collapse>
            </b-list-group-item>
        </b-list-group>
        <b-badge @click="addVehicle" id="add-button"> Add vehicle </b-badge>
        <b-button-group>
            <b-button @click="update" variant="success"> Save </b-button>
            <b-button @click="loadData" variant="warning"> Reset </b-button>
            <b-button @click="downloadData" variant="primary"> Download </b-button>
        </b-button-group>
    </b-sidebar>
</template>

<script>
export default {
    props: [ "vehicleData" ],
    data() {
        return {
            data: [],
            attributes: [
                { name: "name", label: "Name", required: true },
                { name: "maxCharge", label: "Max Charge", type: "number", step: "0.1", required: true },
                { name: "currentChargeInkWh", label: "Current Charge", type: "number", step: "0.1" },
                { name: "uphillEfficiency", label: "Uphill Efficiency", type: "number", step: "0.01", max: "1" },
                { name: "downhillEfficiency", label: "Downhill Efficiency", type: "number", step: "0.01", max: "1" },
                { name: "constantSpeedConsumption", label: "Constant Speed Consumption", placeholder: "30,6.4:65,9.2:120,22.1", required: true },
                { name: "minChargeAtDestinationInkWh", label: "Min Charge at Destination (kWh)", type: "number", step: "0.01" },
                { name: "minChargeAtChargingStopsInkWh", label: "Min Charge at Charging Stops (kWh)", type: "number", step: "0.01" },
                { name: "weight", label: "Weight (kg)", type: "number" },
                { name: "color", label: "Color", type: "color" },
                { name: "auxiliaryPower", label: "Auxiliary Power", type: "number", step: "0.01", max: "1" },
            ]
        }
    },
    watch: {
        vehicleData() {
            this.loadData();
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        addVehicle() {
            const newVehicle = {
                name: `Vehicle ${this.data.length + 1}`
            };
            this.data.push(newVehicle);
        },
        deleteVehicle(name) {
            this.data = this.data.filter(vehicle => vehicle.name != name);
        },
        loadData() {
            this.data = JSON.parse(JSON.stringify(this.vehicleData)); // make a copy
            this.data.forEach((vehicle) => {
                vehicle["rawBody"] = JSON.stringify(vehicle.body, null, 2);
                if (vehicle.active == null)
                    vehicle["active"] = true;
            });
        },
        downloadData() {
            const a = document.createElement('a');
            this.data.forEach((vehicle) => {
                vehicle.body = JSON.parse(vehicle.rawBody);
                this.attributes.forEach((attribute) => {
                    if (!(attribute.type && attribute.type == "number"))
                        return;
                    vehicle[attribute.name] = Number(vehicle[attribute.name]);
                });
            });
            a.href = URL.createObjectURL(
                new Blob([JSON.stringify(this.data, null, 4)], {
                    type: 'text/plain',
                })
            );
            a.setAttribute('download', 'vehicleData.json');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        update() {
            this.data.forEach((vehicle) => {
                vehicle.body = JSON.parse(vehicle.rawBody);
                this.attributes.forEach((attribute) => {
                    if (!(attribute.type && attribute.type == "number"))
                        return;
                    if (!vehicle[attribute.name])
                        return;
                    vehicle[attribute.name] = Number(vehicle[attribute.name]);
                });
            });
            this.$emit("change", this.data);
            this.$bvToast.toast(`The vehicle data has been updated`, {
                title: 'Updated',
                autoHideDelay: 2500,
                variant: "success"
            });
        }
    }
};
</script>

<style scoped src="./VehicleSidebar.css">
</style>